import { Link } from 'react-router-dom';
import { CMIcon } from './primitives';

interface SectionHeadProps {
  title: string;
  sub?: string;
  linkHref?: string;
  linkLabel?: string;
  /** Render a slot on the right (overrides linkHref/linkLabel). */
  rightSlot?: React.ReactNode;
  className?: string;
}

/**
 * Section heading used by every page: bold title + optional sub + optional
 * right link. The link uses react-router. Matches design's `.cm-sec-head`.
 */
export function SectionHead({ title, sub, linkHref, linkLabel, rightSlot, className = '' }: SectionHeadProps) {
  return (
    <div className={`mb-4 flex flex-wrap items-end justify-between gap-3 ${className}`}>
      <div>
        <h2 className="text-[17px] font-extrabold tracking-tight text-slate-900 dark:text-white">{title}</h2>
        {sub && <p className="mt-0.5 text-[13px] text-slate-500 dark:text-slate-400">{sub}</p>}
      </div>
      {rightSlot
        ? rightSlot
        : linkHref && linkLabel && (
            <Link
              to={linkHref}
              className="flex items-center gap-1 text-[13px] font-semibold text-blue-600 transition-colors hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
            >
              {linkLabel}
              <CMIcon name="arrowright" size={13} />
            </Link>
          )}
    </div>
  );
}
